/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ValidationFaultPaymentDataError } from "./ValidationFaultPaymentDataError";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_DATA_ERROR" = "PAYMENT_DATA_ERROR"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to validation errors.
 */

// required attributes
const ValidationFaultPaymentDataErrorProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: ValidationFaultPaymentDataError
});

// optional attributes
const ValidationFaultPaymentDataErrorProblemJsonO = t.partial({
  title: t.string
});

export const ValidationFaultPaymentDataErrorProblemJson = t.intersection(
  [
    ValidationFaultPaymentDataErrorProblemJsonR,
    ValidationFaultPaymentDataErrorProblemJsonO
  ],
  "ValidationFaultPaymentDataErrorProblemJson"
);

export type ValidationFaultPaymentDataErrorProblemJson = t.TypeOf<
  typeof ValidationFaultPaymentDataErrorProblemJson
>;
